export const GUEST_RESERVATIONS_ACTION_URL = '/visitors';
